import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Box, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Attachment from "../../../../../Components/Broker/Attachment/Attachment";
import EmailComponent from "../../../../../Components/Broker/EmailComponent/EmailComponent";
import NotesSection from "../../../../../Components/Broker/NotesSection/NotesSection";
import TasksSection from "../../../../../Components/Broker/TasksSection/TasksSection";
import DatePicker from "../../../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
import "../../../../../formLayout.scss";
function AddNewEmployee() {
  const navigate = useNavigate();
  const [notesData, setNotesData] = useState<
    Array<{ name: string; date: Date; description: string }>
  >([]);

  const [Dob, setDob] = React.useState<Date | null>(new Date());
  const [Doj, setDoj] = React.useState<Date | null>(null);
  const [viewTabsStatus, setViewTabsStatus] = React.useState("overview");
  const [organizationName, setOrganizationName] = React.useState("");
  const [orgNumber, setOrgNumber] = React.useState("");
  const [orgEmail, setOrgEmail] = React.useState("");
  const [personalemail, setPersonalEmail] = React.useState("");
  const [mobilenumber, setMobileNumber] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  //   const [middleName, setMiddleName] = React.useState("");
  const [lastName, setLastName] = React.useState("");
  const [Department, setDepartment] = React.useState("");
  const [Designation, setDesignation] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [buildingName, setBuildingName] = React.useState("");
  const [areaName, setAreaName] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [State, setState] = React.useState("");
  const [location, setLocation] = React.useState("");
  const [orgEmp, setOrgEmp] = React.useState("");
  const [salary, setSalary] = React.useState("");
  const [salaryBracket, setSalaryBracket] = React.useState("");
  const [City, setCity] = React.useState("");
  const [Zipcode, setZipcode] = React.useState("");
  const [emailcomp, setEmailComp] = React.useState(false);
  const [toggle, setToggle] = React.useState(true);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const [sectionStatus, SetSectionStatus] =
    React.useState<string>("personalDetails");
  const [subSection, setSubSection] = React.useState("basicinfo");
  const [postQueryForm, setPostQueryForm] = React.useState(false);
  const [attachment, setAttachment] = React.useState(false);
  const [memberType, setMemberType] = React.useState("");
  const [selectClient, setSelectClient] = React.useState("");
  const [selectEmployee, setSelectEmployee] = React.useState("");
  const [relationEmployee, setRelationEmployee] = React.useState("");

  const gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];
  const member_type_data = [
    { key: "Employee", value: "Employee" },
    { key: "Dependant", value: "Dependant" },
  ];
  const select_client_data = [
    { key: "EV001-Evervent Pvt Ltd", value: "EV001-Evervent Pvt Ltd" },
    { key: "EV002-Evervent Pvt Ltd", value: "EV002-Evervent Pvt Ltd" },
  ];

  const select_employee_data = [
    { key: "EMP0001-Vikas Saini", value: "EMP0001-Vikas Saini" },
    { key: "EMP0001-Vikas Saini", value: "EMP0001-Vikas Saini" },
  ];
  const salaryBracket_data = [
    { key: "Below ₹ 1,00,000", value: "Below ₹ 1,00,000" },
    { key: "₹ 1,00,000 - ₹ 5,00,000", value: "₹ 1,00,000 - ₹ 5,00,000" },
    { key: "₹ 5,00,000 - ₹ 10,00,000", value: "₹ 5,00,000 - ₹ 10,00,000" },
    { key: "Above ₹ 10,00,000", value: "Above ₹ 10,00,000" },
  ];

  const client_data = [
    { label: "EV 065 - Vikas Saini", value: "EV 065 - Vikas Saini" },
    { label: "EV 015 - Umesh Gemini", value: "EV 015 - Umesh Gemini" },
    { label: "EV 016 - Kartike Kakkar", value: "EV 016 - Kartike Kakkar" },
  ];

  const location_data = [
    { label: "Registered Office", value: "Registered Office" },
    { label: "Regional Office", value: "Regional Office" },
    { label: "State Head Office", value: "State Head Office" },
    { label: "City Office", value: "City Office" },
    { label: "City Sub Office", value: "City Sub Office" },
  ];
  const relationEmployee_data = [
    { label: "Self", value: "Self" },
    { label: "Husband", value: "Husband" },
    { label: "Wife", value: "Wife" },
    { label: "Daughter", value: "Daughter" },
    { label: "Son", value: "Son" },
    { label: "Mother", value: "Mother" },
    { label: "Father", value: "Father" },
    { label: "Mother in Law", value: "Mother in Law" },
    { label: "Father in Law", value: "Father in Law" },
  ];

  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];

  const state_data = [
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Punjab", value: "Punjab" },
    { label: "Haryana", value: "Haryana" },
    { label: "Kerla", value: "Kerla" },
    { label: "Delhi", value: "Delhi" },
  ];

  const city_data = [
    { label: "Ambala", value: "Ambala" },
    { label: "Nanital", value: "Nanital" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Jaipur", value: "Jaipur" },
    { label: " New Delhi", value: "New Delhi" },
  ];
  const department_data = [
    { label: "Design", value: "Design" },
    { label: "Human Resources", value: "Human Resources" },
    { label: "Engineering", value: "Engineering" },
    { label: "Management", value: "Management" },
  ];
  const designation_data = [
    { label: "Ass. FrontEnd Developer", value: "Ass. FrontEnd Developer" },
    { label: "Assistant Manager", value: "Assistant Manager" },
    { label: "Ass. Manager", value: "Ass. Manager" },
    { label: "Ass. BackEnd Developer", value: "Ass. BackEnd Developer" },
  ];

  // for scrolling
  const memberDetails = useRef(null);
  const personalDetails = useRef(null);
  const email = useRef(null);
  const attatchmentsdetails = useRef(null);
  const tododetails = useRef(null);
  const notes = useRef(null);
  const policies = useRef(null);
  //const ref = useRef(null);
  const memberinfo = useRef(null);
  const basicinfo = useRef(null);
  const professional = useRef(null);
  const addressdetails = useRef(null);
  //const personaladdress = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  //Table Data
  const [data, setData] = React.useState<
    Array<{
      title: string;
      title_class: string;
      data: Array<{
        open_status: boolean;
        title: string;
        status: string;
        due_date: string;
        priority: string;
        priority_class: string;
        linked_to: string;
        assignee: Array<string>;
        creation_date: string;
        creation_time: string;
        sub_data: Array<{
          title: string;
          status: string;
          due_date: string;
          priority: string;
          priority_class: string;
          linked_to: string;
          assignee: Array<string>;
          creation_date: string;
          creation_time: string;
        }>;
      }>;
    }>
  >([
    {
      title: "Started",
      title_class: "green",
      data: [
        {
          open_status: false,
          title: "Follow Up",
          status: "started",
          due_date: "31 Dec",
          priority: "High",
          priority_class: "high",
          linked_to: "Quotes-QT25",
          assignee: ["U", "R"],
          creation_date: "23 Dec",
          creation_time: "17:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
        {
          open_status: false,
          title: "Follow Up",
          status: "inqueue",
          due_date: "28 Dec",
          priority: "Low",
          priority_class: "low",
          linked_to: "Quotes-QT28",
          assignee: ["U", "R"],
          creation_date: "10 Dec",
          creation_time: "13:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
        {
          open_status: false,
          title: "Follow Up",
          status: "completed",
          due_date: "25 Dec",
          priority: "Highest",
          priority_class: "highest",
          linked_to: "Quotes-QT23",
          assignee: ["U", "R"],
          creation_date: "3 Dec",
          creation_time: "19:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
      ],
    },
  ]);

  const updateMasterState = (attrName: any, value: string) => {
    attrName(value);
  };

  const handleClick = () => {
    setToggle(!toggle);
  };
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const employee_table_data = [
    {
      policy_no: "PVAZ23456788",
      product_type: "Group Health",
      insurer: "HDFC Ergo",
      basic_config: "1E+1S+1C+1C+1C+1C",
      individual_config: "Nill",
      checkbox_status: false,
      check_status: "",
    },
    {
      policy_no: "PVAZ23456788",
      product_type: "Group Term",
      insurer: "Star",
      basic_config: "1E+1S+1C+1C+1C",
      individual_config: "1P+1P",
      checkbox_status: false,
      check_status: "",
    },
    {
      policy_no: "PVAZ23456788",
      product_type: "Group Personal Accident",
      insurer: "Bajaj Allianz",
      basic_config: "1E+1S+1C+1C",
      individual_config: "1PIL+1PIL",
      checkbox_status: false,
      check_status: "",
    },
    {
      policy_no: "PVAZ23456788",
      product_type: "Group Critical Illness",
      insurer: "Royal Sundaram",
      basic_config: "1E+1S+1C",
      individual_config: "1P+1P+1PIL+1PIL",
      checkbox_status: false,
      check_status: "",
    },
  ];

  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/homebroker?page=employe");
            }}
          >
            <ChevronLeftIcon />
          </Link>
          {/* <span className="detailIcon">A</span> */}
          <div>
            <h3>Add New Member</h3>
          </div>
        </Grid>
        <Grid
          xs={6}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        ></Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="leftSection h-100">
              <Link
                className={
                  sectionStatus === "memberDetails"
                    ? "active sectionLink memberDetails"
                    : "sectionLink memberDetails"
                }
                onClick={() => {
                  scrollToSection(memberDetails);
                  SetSectionStatus("memberDetails");
                }}
              >
                <span> Member Details</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "memberinfo"
                        ? "inner_link active memberinfo"
                        : "inner_link memberinfo"
                    }
                    onClick={() => {
                      setSubSection("memberinfo");
                      handleClicks(subSection);
                      scrollToSection(memberinfo);
                    }}
                  >
                    Member info
                  </Link>
                </li>
              </ul>
              <Link
                className={
                  sectionStatus === "personalDetails"
                    ? "active sectionLink personalDetails"
                    : "sectionLink personalDetails"
                }
                onClick={() => {
                  scrollToSection(personalDetails);
                  SetSectionStatus("personalDetails");
                }}
              >
                <span> Personal Details</span>
              </Link>
              <ul className="accordion_list">
                <li>
                  <Link
                    className={
                      subSection === "basicinfo"
                        ? "inner_link active basicinfo"
                        : "inner_link basicinfo"
                    }
                    onClick={() => {
                      setSubSection("basicinfo");
                      handleClicks(subSection);
                      scrollToSection(basicinfo);
                    }}
                  >
                    Basic info
                  </Link>
                </li>
                <li>
                  <Link
                    className={
                      subSection === "professional"
                        ? "inner_link active professional"
                        : "inner_link professional"
                    }
                    onClick={() => {
                      setSubSection("professional");
                      handleClicks(subSection);
                      scrollToSection(professional);
                    }}
                  >
                    Professional Details
                  </Link>
                </li>
              </ul>

              <Link
                className={
                  sectionStatus === "addressdetails"
                    ? "active sectionLink addressdetails"
                    : "sectionLink addressdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(addressdetails);
                  SetSectionStatus("addressdetails");
                }}
              >
                <span>Address Details</span>
              </Link>

              <Link
                className={
                  sectionStatus === "policies"
                    ? "active sectionLink policies"
                    : "sectionLink policies"
                }
                onClick={() => {
                  scrollToSection(policies);
                  SetSectionStatus("policies");
                }}
              >
                <span>Policies</span>
              </Link>
              <Link
                className={
                  sectionStatus === "email"
                    ? "active sectionLink email"
                    : "sectionLink email"
                }
                onClick={() => {
                  scrollToSection(email);
                  SetSectionStatus("email");
                }}
              >
                <span>Email</span>
              </Link>

              {/* <Link
                className={
                  sectionStatus === "attatchmentsdetails"
                    ? "active sectionLink attatchmentsdetails"
                    : "sectionLink attatchmentsdetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(attatchmentsdetails);
                  SetSectionStatus("attatchmentsdetails");
                }}
              >
                <span>Attatchments</span>
              </Link>

              <Link
                className={
                  sectionStatus === "tododetails"
                    ? "active sectionLink tododetails"
                    : "sectionLink tododetails"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(tododetails);
                  SetSectionStatus("tododetails");
                }}
              >
                <span> Tasks</span>
              </Link>
              <Link
                className={
                  sectionStatus === "notes"
                    ? "active sectionLink notes"
                    : "sectionLink notes"
                }
                onClick={() => {
                  handleClicks(sectionStatus);
                  scrollToSection(notes);
                  SetSectionStatus("notes");
                }}
              >
                <span>Notes</span>
              </Link> */}
            </Grid>
            <Grid xs className="rightSection h-100">
              {viewTabsStatus == "overview" ? (
                <>
                  <Box className="detailSection" ref={memberDetails}>
                    <div className="sectionTitle">
                      <h4>Member Type Details</h4>
                    </div>
                    <div ref={memberinfo}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Member Type info</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={4} md={4} lg={3} xl={3}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Member Type"
                            value={memberType}
                            attrName={setMemberType}
                            value_update={updateMasterState}
                            dropdown_data={member_type_data}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={3}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Select Client"
                            value={selectClient}
                            attrName={setSelectClient}
                            value_update={updateMasterState}
                            dropdown_data={select_client_data}
                            warn_status={false}
                          />
                        </Grid>
                        {memberType === "Dependant" ? (
                          <Grid sm={4} md={4} lg={3} xl={3}>
                            <SelectDropdown
                              class_name="inputField"
                              title="Select Primary Employee"
                              value={selectEmployee}
                              attrName={setSelectEmployee}
                              value_update={updateMasterState}
                              dropdown_data={select_employee_data}
                              warn_status={false}
                            />
                          </Grid>
                        ) : null}
                      </Grid>
                    </div>
                  </Box>
                  <Box className="detailSection" ref={personalDetails}>
                    <div className="sectionTitle">
                      <h4>Personal Details</h4>
                    </div>
                    <div ref={basicinfo}>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Basic info</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={4} md={4} lg={3} xl={3}>
                          <RKTextField
                            class_name="inputField"
                            title="First Name"
                            value={firstName}
                            attrName={setFirstName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Last Name"
                            value={lastName}
                            attrName={setLastName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={4} md={4} lg={3} xl={3}>
                          <SelectDropdown
                            class_name="inputField"
                            title="Gender"
                            value={gender}
                            attrName={setGender}
                            value_update={updateMasterState}
                            dropdown_data={gender_data}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={3}>
                          <DatePicker
                            class_name="inputField"
                            title="Date of Birth"
                            value={Dob}
                            attrName={setDob}
                            value_update={updateMasterState}
                            error_message="Please enter Date of Birth"
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Relationship with Employee"
                            value={relationEmployee}
                            attrName={setRelationEmployee}
                            value_update={updateMasterState}
                            data={relationEmployee_data}
                            warn_status={false}
                            error_message="Please select relation"
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Contact Number"
                            value={mobilenumber}
                            attrName={setMobileNumber}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={4} md={4} lg={3} xl={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Email"
                            value={personalemail}
                            attrName={setPersonalEmail}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>

                    {memberType === "Employee" ? (
                      <div ref={professional}>
                        <Grid container spacing={3}>
                          <Grid xs={12}>
                            <h5 className="subHeading">Professional Details</h5>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid xs={6} md={4} lg={3} xl={3}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Select Client"
                              value={organizationName}
                              attrName={setOrganizationName}
                              value_update={updateMasterState}
                              data={client_data}
                              warn_status={false}
                              error_message="Please select client"
                            />
                          </Grid>
                          <Grid xs={6} md={4} lg={3} xl={3}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Location"
                              value={location}
                              attrName={setLocation}
                              value_update={updateMasterState}
                              data={location_data}
                              warn_status={false}
                              error_message="Please select client"
                            />
                          </Grid>
                          <Grid sm={4} md={4} lg={3} xl={3}>
                            <RKTextField
                              class_name="inputField"
                              title="Organization Employee ID "
                              value={orgEmp}
                              attrName={setOrgEmp}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>

                        <Grid container spacing={3}>
                          <Grid sm={6} md={6} lg={3} xl={3}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Department"
                              value={Department}
                              attrName={setDepartment}
                              value_update={updateMasterState}
                              data={department_data}
                              warn_status={false}
                              error_message="Please select Department"
                            />
                          </Grid>
                          <Grid sm={6} md={6} lg={3} xl={3}>
                            <SearchDropdown
                              class_name="inputField"
                              title="Designation"
                              value={Designation}
                              attrName={setDesignation}
                              value_update={updateMasterState}
                              data={designation_data}
                              warn_status={false}
                              error_message="Please select Designation"
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid sm={4} md={4} lg={3} xl={3}>
                            <RKTextField
                              class_name="inputField"
                              title={"Salary"}
                              value={salary}
                              attrName={setSalary}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid sm={4} md={4} lg={3} xl={3}>
                            <SelectDropdown
                              class_name="inputField"
                              title="Salary Bracket"
                              value={salaryBracket}
                              attrName={setSalaryBracket}
                              value_update={updateMasterState}
                              dropdown_data={salaryBracket_data}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          <Grid sm={4} md={4} lg={3} xl={3}>
                            <DatePicker
                              class_name="inputField"
                              title="Date of Joining"
                              value={Doj}
                              attrName={setDoj}
                              value_update={updateMasterState}
                              error_message="Please enter Date of joining"
                              warn_status={false}
                            />
                          </Grid>
                          <Grid sm={4} md={4} lg={3} xl={3}>
                            <RKTextField
                              class_name="inputField"
                              title={"Office Email"}
                              value={orgEmail}
                              attrName={setOrgEmail}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                          <Grid sm={4} md={4} lg={3} xl={3}>
                            <RKTextField
                              class_name="inputField"
                              title={"Office Contact Number"}
                              value={orgNumber}
                              attrName={setOrgNumber}
                              value_update={updateMasterState}
                              warn_status={false}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    ) : null}
                  </Box>

                  <Box className="detailSection" ref={addressdetails}>
                    <div className="sectionTitle">
                      <h4>Personal Address Details</h4>
                    </div>

                    <div>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">
                            Personal Address Details
                          </h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Building/Street Name"
                            value={buildingName}
                            attrName={setBuildingName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <RKTextField
                            class_name="inputField"
                            title="Area Name"
                            value={areaName}
                            attrName={setAreaName}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="Country"
                            value={country}
                            attrName={setCountry}
                            value_update={updateMasterState}
                            data={country_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="State"
                            value={State}
                            attrName={setState}
                            value_update={updateMasterState}
                            data={state_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <SearchDropdown
                            class_name="inputField"
                            title="City"
                            value={City}
                            attrName={setCity}
                            value_update={updateMasterState}
                            data={city_data}
                            warn_status={false}
                            error_message="Please select client"
                          />
                        </Grid>
                        <Grid sm={6} md={4} lg={3} xl={3}>
                          <RKTextField
                            class_name="inputField"
                            title={"Zipcode"}
                            value={Zipcode}
                            attrName={setZipcode}
                            value_update={updateMasterState}
                            warn_status={false}
                          />
                        </Grid>
                      </Grid>
                    </div>
                  </Box>

                  {/* comment code for phase 2 */}
                  {/* <Box className="detailSection" ref={policies}>
                    <div className="sectionTitle">
                      <h4>Policies</h4>
                    </div>
                    <div>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <h5 className="subHeading">Add Employee to Policy</h5>
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid xs={12}>
                          <div className="employee_table">
                            <div
                              className="employee_innerpart"
                              style={{ overflow: "hidden" }}
                            >
                              <ul className="heading">
                                <li>Active Policy Number</li>
                                <li>Product Type</li>
                                <li>Insurer</li>
                                <li>Basic configuration</li>
                                <li>Individual configuration</li>
                                <li>Choose Policy</li>
                              </ul>

                              {employee_table_data.map((data, index) => (
                                <ul className="subheading">
                                  <li>{data.policy_no}</li>
                                  <li>{data.product_type}</li>
                                  <li>{data.insurer}</li>
                                  <li>{data.basic_config}</li>
                                  <li>{data.individual_config}</li>
                                  <li>
                                    <div className="Checkbox">
                                      <input type="checkbox" name="check" />
                                      <label className="employee"></label>
                                    </div>
                                  </li>
                                </ul>
                              ))}
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </Box> */}

                  {/* comment code for phase 2 */}
                  {/* we have hide this section for phase 2 */}
                  {/* <Box className="detailSection" ref={email}>
                    <div className="sectionTitle">
                      <h4>Emails </h4>
                      <div className="actionBtns">
                        <Link
                          className="redBtn delete"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Delete
                        </Link>

                        <Link
                          className="blueBtn edit"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Compose
                        </Link>
                      </div>
                    </div>

                    <EmailComponent
                      open_status={emailcomp}
                      attrName={setEmailComp}
                      value_update={updateMasterState}
                    />
                  </Box> */}

                  {/* comment code for phase 2 */}
                  {/* attachment , task and notes commented  */}

                  {/* <Box className="detailSection" ref={attatchmentsdetails}>
                    <div className="sectionTitle">
                      <h4>Attachments </h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => setUploadFile(true)}
                        >
                          Add Document
                        </Link>
                      </div>
                    </div>
                    <Attachment
                      open_status={attachment}
                      attrName={setAttachment}
                      value_update={updateMasterState}
                    />
                  </Box>
                  <Box className="detailSection" ref={tododetails}>
                    <div className="sectionTitle">
                      <h4>Tasks</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                        >
                          Add Task
                        </Link>
                      </div>
                    </div>
                    <Grid container spacing={3}>
                      <Grid xs={12}>
                        <TasksSection />
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="detailSection" ref={notes}>
                    <div className="sectionTitle">
                      <h4>Notes</h4>

                      <div className="actionBtns">
                        <Link
                          className="blueBtn addfile"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={() => {
                            setPostQueryForm(true);
                          }}
                        >
                          Add Notes
                        </Link>
                      </div>
                    </div>

                    <NotesSection data={notesData} />
                  </Box> */}
                </>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
export default AddNewEmployee;
